import { z } from 'zod'

/**
 * A package (a bundle, priced as a whole) or an item (one thing, priced alone).
 * Mirrors the Prisma `VendorOfferingKind` enum (`check:enums`).
 */
export const VENDOR_OFFERING_KINDS = ['package', 'item'] as const

export const vendorOfferingKindSchema = z.enum(VENDOR_OFFERING_KINDS)

export type VendorOfferingKind = z.infer<typeof vendorOfferingKindSchema>

export const VENDOR_OFFERING_KIND_LABELS: Record<VendorOfferingKind, string> = {
  package: 'Package',
  item: 'Item',
}
